// Components
import EveryDollarCallToAction from './EveryDollarCallToAction';
import PremiumFeatures from './PremiumFeatures';

function Budget() {
  return (
    <div className="max-w-[1000px]">
      <EveryDollarCallToAction />
      <PremiumFeatures />
    </div>
  );
}

export default Budget;
